import { useEffect, useState } from "react"
import { PerPlayerStockData } from "../components/PerPlayerStockData";
import { getAllPlayerInfo } from "../tools/PlayerTools";

export const AllPlayerHoldings = () => {
    const [allPlayerInfo, setAllPlayerInfo] = useState({details:[]});
    useEffect(() => {
        if (!localStorage.getItem("token")) {
            window.location.href = "/";
        }
        getAllPlayerInfo(true).then(data => {
            if (!data.error) {
                setAllPlayerInfo(data);
            }
        }).catch(e => { });
    },[])
    return <div style={{marginTop:"18px"}}><PerPlayerStockData allPlayerInfo={allPlayerInfo.details} size="sm" /></div>
}